export function addQueryParams(baseUrl: string, additionalQueryParams: string): string {
  const url = new URL(baseUrl);
  const searchParams = new URLSearchParams(url.search);
  const additionalSearchParams = new URLSearchParams(additionalQueryParams);

  for (const [key, value] of additionalSearchParams.entries()) {
    searchParams.set(key, value);
  }

  url.search = searchParams.toString();
  return url.toString();
}
